import { render } from "./A.vue?vue&type=template&id=4071967a"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/A.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4071967a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4071967a', __exports__)) {
    api.reload('4071967a', __exports__)
  }
  
  module.hot.accept("./A.vue?vue&type=template&id=4071967a", () => {
    api.rerender('4071967a', render)
  })

}


export default __exports__